// Material 3 component kit. Importing anything from here also ensures the design tokens
// (CSS variables generated from theme/style/m3Palette.js) are loaded.
import { injectM3Tokens } from "../../theme/style/m3Palette";

injectM3Tokens();

// Actions
export { default as M3Button } from "./M3Button";
export { default as M3IconButton } from "./M3IconButton";
export { default as M3Menu } from "./M3Menu";
export { default as SplitButton } from "./SplitButton";
export { default as OverflowMenu } from "./OverflowMenu";

// Navigation and selection
export { default as M3Toolbar } from "./M3Toolbar";
export { default as SelectionActionBar } from "./SelectionActionBar";
export { default as SegmentedButton } from "./SegmentedButton";
export { default as ModeSelector } from "./ModeSelector";
export { default as ViewToggle, VIEW_MODES } from "./ViewToggle";

// Display
export { default as Chip } from "./Chip";
export { default as StatusChip } from "./StatusChip";
export { default as M3Badge } from "./M3Badge";
export { default as KpiTile } from "./KpiTile";
export { SpecList, KpiGrid } from "./SpecList";
export { default as EmptyState } from "./EmptyState";
export { default as Banner } from "./Banner";

// Forms
export { default as SideSheet } from "./SideSheet";
export { FormSection, FieldGrid } from "./FormSection";
export { default as M3Field } from "./M3Field";
export { default as M3Dropdown } from "./M3Dropdown";
export { default as M3DatePicker } from "./M3DatePicker";
export { default as M3GridSelectEditor } from "./M3GridSelectEditor";

// Layout
export { default as M3Surface } from "./M3Surface";
export { default as PageHeader } from "./PageHeader";
export { default as WorkspaceHeader } from "./WorkspaceHeader";
export { default as DataTableCard } from "./DataTableCard";
export { default as ChartCard } from "./ChartCard";
export { default as GlobalViewSection, GlobalViewToggle } from "./GlobalViewSection";

// Overlays & Dialogs
export { default as M3Dialog, M3ConfirmDialog } from "./M3Dialog";
